export const USER_EXPIRED = 'USER_EXPIRED'

export const REDIRECT_SUCCESS = 'REDIRECT_SUCCESS'
export const SILENT_RENEW_ERROR = 'SILENT_RENEW_ERROR'
export const SESSION_TERMINATED = 'SESSION_TERMINATED'
export const USER_EXPIRING = 'USER_EXPIRING'
export const USER_FOUND = 'USER_FOUND'
export const USER_FOUND_AUTHZ_CODE_FLOW = 'USER_FOUND_AUTHZ_CODE_FLOW'
export const UPDATE_ADDITIONAL_USER_DETAILS = 'UPDATE_ADDITIONAL_USER_DETAILS'
export const LOADING_USER = 'LOADING_USER'
export const USER_SIGNED_OUT = 'USER_SIGNED_OUT'
export const LOAD_USER_ERROR = 'LOAD_USER_ERROR'
export const UPDATE_USER_IMAGE = 'UPDATE_USER_IMAGE'
export const UPDATE_FSE = 'UPDATE_FSE'
export const UPDATE_USER = 'UPDATE_USER'
export const SELECT_FSE = 'SELECT_FSE'
export const UPDATE_BANK_BRANCH = 'UPDATE_BANK_BRANCH'
export const SET_POSITION_CODE = 'SET_POSITION_CODE'
export const SET_REGISTRATION = 'SET_REGISTRATION'
export const UPDATE_STAFF_ID = 'UPDATE_STAFF_ID'
export const UPDATE_STAFF_NAME = 'UPDATE_STAFF_NAME'
export const UPDATE_STAFF_SURNAME = 'UPDATE_STAFF_SURNAME'
export const UPDATE_STAFF_POSITION = 'UPDATE_STAFF_POSITION'
export const UPDATE_CHECK_NATIVE_APPVERSION_USER = 'UPDATE_CHECK_NATIVE_APPVERSION_USER'

export const setPositionCode = (positionCode) => ({
  type: SET_POSITION_CODE,
  payload: positionCode,
})

export const setRegistration = (registration) => ({
  type: SET_REGISTRATION,
  payload: registration,
})

export const updateUserImage = (userImage) => ({
  type: UPDATE_USER_IMAGE,
  payload: userImage,
})

export const updateUser = (user) => ({
  type: UPDATE_USER,
  payload: user,
})

export const updateCheckNativeAppVersionUser = () => ({
  type: UPDATE_CHECK_NATIVE_APPVERSION_USER,
})

export const userExpired = () => ({
  type: USER_EXPIRED,
})

export const redirectSuccess = (user) => ({
  type: REDIRECT_SUCCESS,
  payload: user,
})

export const updateAdditionalUserDetails = () => ({
  type: UPDATE_ADDITIONAL_USER_DETAILS,
})

export const userFoundAuthzCodeFlow = (idTokenInfo) => ({
  type: USER_FOUND_AUTHZ_CODE_FLOW,
  payload: idTokenInfo,
})

export const userFound = (user) => ({
  type: USER_FOUND,
  payload: user,
})

export const silentRenewError = (error) => ({
  type: SILENT_RENEW_ERROR,
  payload: error,
})

export const sessionTerminated = () => ({
  type: SESSION_TERMINATED,
})

export const userExpiring = () => ({
  type: USER_EXPIRING,
})

export const loadingUser = () => ({
  type: LOADING_USER,
})

export const userSignedOut = () => ({
  type: USER_SIGNED_OUT,
})

export const loadUserError = () => ({
  type: LOAD_USER_ERROR,
})

export const GET_DISTRIBUTOR_GROUPS_REQUEST = 'GET_DISTRIBUTOR_GROUPS_REQUEST'
export const GET_DISTRIBUTOR_GROUPS_SUCCESS = 'GET_DISTRIBUTOR_GROUPS_SUCCESS'
export const GET_DISTRIBUTOR_GROUPS_FAILED = 'GET_DISTRIBUTOR_GROUPS_FAILED'
export const SET_DISTRIBUTOR_GROUP = 'SET_DISTRIBUTOR_GROUP'

export const getDistributorGroupsRequest = () => ({
  type: GET_DISTRIBUTOR_GROUPS_REQUEST,
})

export const getDistributorGroupsSuccess = (distributorGroups) => ({
  type: GET_DISTRIBUTOR_GROUPS_SUCCESS,
  payload: distributorGroups,
})

export const getDistributorGroupsFailed = (error) => ({
  type: GET_DISTRIBUTOR_GROUPS_FAILED,
  error,
})

export const setDistributorGroup = (distributorGroupType) => ({
  type: SET_DISTRIBUTOR_GROUP,
  payload: distributorGroupType,
})

export const updateFSE = (fse) => ({
  type: UPDATE_FSE,
  payload: fse,
})

export const selectFSE = (fse) => ({
  type: SELECT_FSE,
  payload: fse,
})

export const updateOffice = (office) => ({
  type: UPDATE_BANK_BRANCH,
  payload: office,
})

export const updateStaffId = (staffId) => ({
  type: UPDATE_STAFF_ID,
  payload: staffId,
})

export const updateStaffName = (staffName) => ({
  type: UPDATE_STAFF_NAME,
  payload: staffName,
})

export const updateStaffSurname = (staffSurname) => ({
  type: UPDATE_STAFF_SURNAME,
  payload: staffSurname,
})

export const updateStaffPosition = (staffPosition) => ({
  type: UPDATE_STAFF_POSITION,
  payload: staffPosition,
})

export const SET_USER_ADVISOR = 'SET_USER_ADVISOR'
export const SET_AMLO_STATUS = 'SET_AMLO_STATUS'

export const setUserAdvisor = (advisor) => ({
  type: SET_USER_ADVISOR,
  payload: advisor,
})

export const setAmloStatus = ({ hasAccess, reason }) => ({
  type: SET_AMLO_STATUS,
  payload: { hasAccess, reason },
})
